import { i18n } from '../i18n'
import { feeAsset } from '@const'
// import { DIRECTION_VERBOSE } from './help/records.const'

export class TxRecord {
  constructor (record, name) {
    this._record = record
    this.name = name
    this.id = record.id

    this.date = this._getDate()
    this.state = this._record.state // TODO: resolve the state from xdr
    this.feeAsset = feeAsset
  }

  _getDate () {
    return i18n.d(this._record.ledger_close_time)
  }

  _getDirection () {
    return ''
  }

  // get color () {  DEPRECATED
  //   return this.colorByState()
  // }

  get direction () {
    return this._getDirection()
  }

  /*
  /* DEPRECATED
  colorByState () {
    var st = this.state
    // console.log(st)
    if (st === 'pending') return '#ef6c00'
    if (st === 'rejected' || st === 'failed') return '#e3a2a3'

    // success always green
    if (st === 'success') {
      return this._getDirection() === DIRECTION_VERBOSE.out
        ? '#e51f13'
        : '#3fa595'
    }
    if (st === 'fully matched') {
      return '#3fa595'
    }
    return '#3f4244'
  }
  */
}



// WEBPACK FOOTER //
// ./src/js/records/tx.record.js